/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: 3Ntynz3mbk3J
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicDisclaimer.module.css"; // plasmic-import: 3Ntynz3mbk3J/css

createPlasmicElementProxy;

export const PlasmicDisclaimer__VariantProps = new Array();

export const PlasmicDisclaimer__ArgProps = new Array("sectionId");

const $$ = {};

function PlasmicDisclaimer__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <section
      data-plasmic-name={"footer"}
      data-plasmic-override={overrides.footer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_cGVJnrZBpZGCmuty7FxDYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.footer
      )}
      id={(() => {
        try {
          return $props.sectionId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"contentWrapper2"}
        data-plasmic-override={overrides.contentWrapper2}
        className={classNames("all", sty.contentWrapper2)}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames("all", "__wab_text", sty.text)}
        >
          {
            "\u201cAutonomy\u201d is a broad term with different meanings across philosophy, psychology, ethics, and organizational theory. Addressing those nuances is outside the scope of this project. Here, we use autonomy in a specific and practical sense: Autonomy is an individual\u2019s capacity to make self-directed decisions and organize their work according to their own judgment, values, and intentions. In the context of modern digital systems, autonomy also includes the ability to design, choose, and adjust the structures, tools, and processes that shape one\u2019s own work."
          }
        </div>
      </div>
    </section>
  );
}

const PlasmicDescendants = {
  footer: ["footer", "contentWrapper2", "text"],
  contentWrapper2: ["contentWrapper2", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDisclaimer__ArgProps,
          internalVariantPropNames: PlasmicDisclaimer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDisclaimer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footer") {
    func.displayName = "PlasmicDisclaimer";
  } else {
    func.displayName = `PlasmicDisclaimer.${nodeName}`;
  }
  return func;
}

export const PlasmicDisclaimer = Object.assign(
  // Top-level PlasmicDisclaimer renders the root element
  makeNodeComponent("footer"),
  {
    // Helper components rendering sub-elements
    contentWrapper2: makeNodeComponent("contentWrapper2"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicDisclaimer
    internalVariantProps: PlasmicDisclaimer__VariantProps,
    internalArgProps: PlasmicDisclaimer__ArgProps
  }
);

export default PlasmicDisclaimer;
/* prettier-ignore-end */
